const wishlist = {
    namespaced: true,
    state: {
        list: [],
        cartcount: 0
    },
    mutations: {
        setCartCount(state, count) {
            state.cartcount = count;
        },
        addItem(state, product) {
            state.list.push(product);
        },
        removeItem(state, product) {
            for (var i = 0; i < state.list.length; i++) {
                if (state.list[i] === product) {
                    state.list.splice(i, 1);
                    break;
                }
            }
        },
        clear(state, product) {
            for (var i = state.list.length - 1; i >= 0; i--) {
                if (state.list[i] === product) {
                    state.list.splice(i, 1);
                }
            }
        }
    },
    actions: {},
    getters: {
        count: state => {
            return state.list.length;
        },
        cartcount: state => {
            return state.cartcount;
        }
    }
};

export default wishlist;